import { createSlice } from "@reduxjs/toolkit";
import { heartBeatACTION } from "../../actions/heartBeatACTION/heartBeatACTION";
import { getAllRestaurantAction } from "../../actions/heartBeatACTION/heartBeatACTION";

const INITIAL_STATE = {
    heartBeat: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    heartBeatList: {
        data: {
            data: [],
            totalCount: 0
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        requestData: null
    },
    heartbeatDropdown: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
};

const heartBeatReducer = createSlice({
    name: "HeartBeat",
    initialState: INITIAL_STATE,
    reducers: {

        RESET() {
            return INITIAL_STATE;
        },

        ResetHeartBitState(state) {
            state.heartBeat = INITIAL_STATE.heartBeat;
        },

        SetHeartBitListData(state, action) {
            state.heartBeatList = {
                ...state.heartBeatList,
                data: {
                    ...state.heartBeatList.data,
                    data: action.payload.data,
                    totalCount: action.payload.totalCount,
                },
                requestData: action.payload.requestData
            };
        },

        ResetActionDetails(state) {
            state.heartBeat.apiMsg = {
                message: null,
                status: null,
                type: null
            };
        },
    },

    extraReducers: (builder) => {
        // *******************for heart beat data***************************
        builder.addCase(heartBeatACTION.fulfilled, (state, action) => {
            // store full data
            state.heartBeat.data = action.payload.data;

            // api message
            state.heartBeat.apiMsg.status = action.meta.requestStatus;
            state.heartBeat.apiMsg.message = action.payload.message?.message || null;

        });

        builder.addCase(heartBeatACTION.pending, (state, action) => {
            state.heartBeat.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(heartBeatACTION.rejected, (state, action) => {
            state.heartBeat.apiMsg.status = action.meta.requestStatus;
            state.heartBeat.apiMsg.message = action.error?.message || "Something went wrong";
        });
        // *******************for heart beat data***************************

        // *******************for heart beat dropdown data***************************
        builder.addCase(getAllRestaurantAction.fulfilled, (state, action) => {

            // Only set data first time
            if (!state.heartbeatDropdown.data || Object.keys(state.heartbeatDropdown.data).length === 0) {
                state.heartbeatDropdown.data = action.payload.data;
            }

            state.heartbeatDropdown.apiMsg.status = action.meta.requestStatus;
            state.heartbeatDropdown.apiMsg.message = action.payload.message?.message || null;

        });

        builder.addCase(getAllRestaurantAction.pending, (state, action) => {
            state.heartbeatDropdown.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getAllRestaurantAction.rejected, (state, action) => {
            state.heartbeatDropdown.apiMsg.status = action.meta.requestStatus;
            state.heartbeatDropdown.apiMsg.message = action.error?.message || "Something went wrong";
        });
        // *******************for heart beat dropdown data***************************
    },
});

export const {
    RESET,
    ResetHeartBitState,
    SetHeartBitListData,
    ResetActionDetails
} = heartBeatReducer.actions;

export default heartBeatReducer.reducer;